import { particles } from 'app/contracts/Particles';
import { HomeParticleStateType, RepellType } from 'app/enum/Particles';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';

export default class SystemsParticleProcessor {
	private _spacesType: number = 1;

	private _x: number;
	private _y: number;
	private _rx: number;
	private _ry: number;
	private _speed: number;

	constructor(
		private _p: HomeParticle,
		private _sceneProps: particles.ParticlesSceneProps
	) {}

	public tick() {}

	public setSystemsStart() {
		this._p.activeState = HomeParticleStateType.SYSTEMS;

		this._p.activate();
		this._p.orbitPath.active = false;
		this._p.position.disableTimelineX = true;

		this._p.repell.randomisePower(0.0000001, 0.0000001);
	}

	public spacesDIcon(x, y, rx, ry, speed, perpectiveArea): void {
		this._x = x;
		this._y = y;
		this._ry = ry;
		this._rx = rx;
		this._speed = speed;

		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();



		this._p.particlePhysics.active = false;
		this._p.iconPath.scaleActive = false;

		this._p.animatedProps.setEase({
			x: 10 + Math.random() * 50,
			y: 8 + Math.random() * 40,
			scale: 30,
			alpha: 30
		});

		//Wait a little bit to trigger start for rise to top corner effect:
		this._p.counter.millsecsToFrames(50);
		this._p.counter.onTrigger = this._startDIcon.bind(this);
		this._p.counter.start();
	}

	private _startDIcon(): void {
		this._p.orbitPath.active = false;
		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;

		this._p.particlePhysics.active = false;

		this._p.position.set({ x: this._x, y: this._y });

		this._p.iconPath.active = true;
		this._p.setupPath(this._p.iconPath, {
			x: [this._rx, 10],
			y: [this._ry, 10],
			speed: [this._speed, 0.002],
			scale: [0.05, 0.3],
			alpha: [0.03, 0.2]
		});
	}

	public spacesPerspectiveGrid(depth, cords, perpectiveArea, colIndex, rowIndex, animate): void {
		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();

		this._p.depth.active = true;
		this._p.depth.perpectiveArea = perpectiveArea;
		this._p.depth.orginalCords = cords;
		this._p.depth.bounce = false;

		this._p.depth.setDepth(depth, true);

		this._p.orbitPath.active = false;
		this._p.iconPath.active = false;

		this._p.depth.getScale();

		this._p.mouseParallax.setPower({
			x: 0.01 * this._p.depth.getRatio(),
			y: 0.01 * this._p.depth.getRatio()
		});

		this._p.animatedProps.setEase({
			x: 20 - 17 * this._p.depth.getRatio(),
			y: 15 - 12 * this._p.depth.getRatio(),
			scale: 30,
			alpha: 30
		});


		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;

		this._p.particlePhysics.active = false;
	}

	public setPerspectiveOrbit(perpectiveArea, cords): void {
		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();
		this._p.mouseParallax.active = true;

		this._p.depth.active = true;
		this._p.depth.perpectiveArea = perpectiveArea;
		this._p.depth.orginalCords = cords;
		this._p.depth.bounce = false;
		this._p.depth.scaleConfig = { min: 0.1, max: 0.25 };
		this._p.depth.alphaConfig = { min: 0.2, max: 0.65 };

		let dr = Math.random();
		let di = 1 - dr;
		this._p.depth.depth = 1 + dr * 8;
		this._p.animatedProps.setEase({
			x: 4 + 60 * dr,
			y: 4 + 40 * dr,
			scale: 5,
			alpha: 5
		});

		this._p.position.set(cords);

		this._p.counter2.triggerAtFrames = 120 + Math.round(Math.random() * 120);

		let random = Math.ceil(Math.random() * 3);
		this._p.counter2.triggerAtFrames = 60 + random * 15;
		this._p.counter2.loop = false;

		this._p.orbitPath.expandMuliplier = 1;

		this._p.counter2.onTrigger = () => {
			this._p.orbitPath.expandMuliplier = 1 + random * 0.4;

			//Now set new timer to make to 1 again:
			this._p.counter2.triggerAtFrames = 60;
			this._p.counter2.onTrigger = () => {
				this._p.orbitPath.expandMuliplier = 1;
			};
			this._p.counter2.start();
		};

		this._p.counter2.start();

		this._p.orbitPath.active = false;

		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.systemsMouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 20;
		this._p.repell.randomisePower(100, 40);

		this._p.orbitPath.active = true;
		this._p.setupPath(this._p.orbitPath, {
			x: [90 - dr * 20, 0],
			y: [90 - dr * 20, 0],
			speed: [0.3 + Math.random() * 0.3, 0.2 * di],
			scale: [0.1, 0.2],
			alpha: [0.4, 0.8],
			direction: -1,
			randomise: { unsync: true, direction: false }
		});

		this._p.mouseParallax.setPower({
			x: 0.01 * this._p.depth.getRatio(),
			y: 0.01 * this._p.depth.getRatio()
		});
	}

	//DROP is in the line bounce effect
	public leftDrop() {
		this._p.deactivateAllBehaviours(true);
		this._spacesRepellStart();
		this._p.particlePhysics.active = true;
		this._p.particlePhysics.leftDrop();
	}

	//Burst is the physics burst:
	public burstUp() {
		this._p.deactivateAllBehaviours(true);
		this._spacesRepellStart();
		this._p.particlePhysics.active = true;
		this._p.particlePhysics.burstUp();
	}

	public rain() {
		this._p.deactivateAllBehaviours(true);
		this._spacesRepellStart();

		this._p.animatedProps.targetScale = 0.1 + Math.random() * 0.1;
		this._p.animatedProps.targetAlpha = 0.3 + Math.random() * 0.6;

		this._p.animatedProps.setEase({
			x: 1,
			y: 1,
			scale: 30,
			alpha: 30
		});


		this._p.particlePhysics.active = true;
		this._p.particlePhysics.target('systems-target');
	}

	public basicGrid() {
		this._p.deactivateAllBehaviours(true);
		this._spacesRepellStart();
		this._p.animatedProps.targetX = 0;
		this._p.animatedProps.targetY = 0;

		this._p.animatedProps.targetScale = 0.17;
		this._p.animatedProps.targetAlpha = 0.7;
	}

	public lineDrop(depth, cords, perpectiveArea, colIndex, rowIndex, animate): void {
		this._p.deactivateAllBehaviours(true);

		this._spacesRepellStart();

		this._p.particlePhysics.drop();
		this._p.particlePhysics.depth = this._p.depth.active ? this._p.depth : null;
		this._p.particlePhysics.active = true;
		this._p.orbitPath.active = false;
		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;

		this._p.counter.millsecsToFrames(1500);
		this._p.counter.onTrigger = this._doBurst.bind(this);
		this._p.counter.start();
	}

	private _doBurst() {
		this._p.particlePhysics.burst();
		this._p.animatedProps.targetAlpha = 0.7 + Math.random() * 0.3;
	}

	/**
	 * Set intial state of spaces scene > box particles:
	 */
	public initSpacesBoxIcon(reset: boolean = true): void {
		this._p.position.set({ x: 0.8, y: 0.45 }, true);

		if (reset) {
			this._p.deactivateAllBehaviours(true);
		}

		this._p.position.trackMouse = false;


		Math.random();

		this._p.animatedProps.targetScale = 0.2;
		this._p.animatedProps.targetAlpha = 0.7;


		this._p.orbitPath.active = true;
		this._p.setupPath(this._p.orbitPath, {
			x: [0, 9 / this._spacesType],
			y: [0, 9 / this._spacesType],
			speed: [0.2, 0.4],
			scale: [0.1, 0.2],
			alpha: [0.4, 0.8],
			direction: -1,
			randomise: { unsync: true, direction: false }
		});

		this._p.orbitPath.xMuliplier = this._p.orbitPath.yMuliplier = 0;
		this._p.orbitPath.active = false;

		this._p.mouseParallax.active = true;
		this._p.mouseParallax.setPower({
			x: 0.01 / this._spacesType,
			y: 0.01 / this._spacesType
		});

		this._p.animatedProps.setEase({
			x: 10 + Math.random() * 50,
			y: 8 + Math.random() * 40,
			scale: 30,
			alpha: 30
		});

		this._p.hover.active = false;

		this._spacesRepellStart();

		this.tick();
	}



	private _spacesRepellStart() {
		this._p.repell.active = false;
		this._p.repell.target = this._sceneProps.targets.systemsMouse;

		this._p.repell.type = RepellType.VECTOR;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 100;
		this._p.repell.randomisePower(0.0000001, 0.0000001);
	}
}
